import { render, staticRenderFns } from "./AddressListDetail.vue?vue&type=template&id=517149e8&scoped=true"
import script from "./AddressListDetail.vue?vue&type=script&lang=js"
export * from "./AddressListDetail.vue?vue&type=script&lang=js"
import style0 from "./AddressListDetail.vue?vue&type=style&index=0&id=517149e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517149e8",
  null
  
)

export default component.exports